// extracted by mini-css-extract-plugin
export var contentBody = "_cq-9";
export var headerImage = "_cq-2";
export var imageButton = "_cq-7";
export var imageButtonIcon = "_cq-8";
export var imageHeader = "_cq-4";
export var imageHeaderText = "_cq-5";
export var imageOverlay = "_cq-3";
export var imageTitle = "_cq-6";
export var imageWrapper = "_cq-1";
export var taskList = "_cq-a";
export var widget = "_cq-0";